<template>
  <span>
    {{ status }}
    <a-icon :type="iconType" />
  </span>
</template>

<script>

import AIcon from 'ant-design-vue/lib/icon'
import 'ant-design-vue/lib/icon/style/index.css'

export default {
  name: 'announcement-status',
  components: {
    AIcon,
  },
  props: {
    iconType: {
      type: String,
      required: true,
    },
    status: {
      type: String,
      required: true,
    },
  },
}
</script>
